<script lang="ts" setup>
import { inject, computed } from 'vue';

import type { Ref } from 'vue';
import type { IManifest, IManifestHotspot } from '@/types/IManifest';

const manifest = inject('manifest') as Ref<IManifest>;
const hotspot = inject('hotspot') as Ref<IManifestHotspot>;
const manifestViews = computed(() => Object.keys(manifest.value.views));
</script>

<template>
  <div class="flex flex-row items-center">
    <label class="text-xs mr-2">Perspective</label>
    <select v-model="hotspot.perspective" class="text-xs border px-1 py-0.5 flex-grow max-w-[175px]">
      <option value="">
        No change
      </option>
      <option v-for="perspective in manifestViews" :key="perspective" :value="perspective">
        {{ perspective }}
      </option>
    </select>
  </div>
</template>
